/* eslint no-unused-vars: 1 */

(function() {
    /** the login controller for shop login only with the nba */
    'use strict';
    angular.module('shopAuth').controller('shopAuthCtrl', shopAuthCtrl);
    shopAuthCtrl.$inject = [ '$rootScope', '$scope', '$injector', '$location', 'mnpNbaProvider', 'mnploginProvider', 'mnpCookieService', '$http', '$stateParams', '$state', 'trackingSrv'
    ];
    function shopAuthCtrl($rootScope, $scope, $injector, $location, mnpNbaProvider, mnploginProvider, mnpCookieService, $http, $stateParams, $state, trackingSrv) {

        var vm = this;
        vm.$onInit = function () {

            var config = $injector.get('config');

            vm.data = $stateParams.params;
            vm.credentials = {
                username: '',
                password: '',
                system: '',
            };
            vm.errorCode = null;
            $rootScope.loading = true;

            vm.selfLocationStart = document.location.href.split('#')[0];
            vm.passwordToggle = 'password';
            vm.statusLink = config.linkUrls.status;
            vm.successPage = 'porting-logged';

            if ('shopLogin' === document.location.href.split('#!/')[1]) {
                // Redirect to MTAN login page
                window.location.href = '/shop/authentifizierung.html?btype=mnp&goto=%2Fhilfe%2Frufnummernmitnahme%2Fstart.html';
                return false;
            }

            /** send the form */
            vm.executeLogin = function(system) {

                vm.credentials.system = system;
                var tuser = vm.credentials.username.toString();

                if ('KIAS' === system) {
                    tuser = mnploginProvider.convertMSISDN(tuser);
                }

                $rootScope.loading = true;
                mnploginProvider.login(tuser, vm.credentials.password, system).then(handleLoginSuccess, handleLoginError);

            };

            /**
             * login successfull, goto home page and check there for nba
             */
            function handleLoginSuccess(response) {
                $rootScope.loading = false;
                window.location.assign('/hilfe/rufnummernmitnahme/start.html');
            }

            function handleLoginError(response) {

                trackingSrv.trackError(response.data.responseCode, trackingSrv.E_TYPE_NOTIFICATION, response.data.description, $state.current.url);

                $rootScope.loading = false;
                vm.errorText = 'Es ist ein Problem aufgetreten. Versuchen Sie es sp&auml;ter noch einmal.';
                if ('undefined' !== typeof response.data.responseCode) {
                    vm.errorCode = response.data.responseCode.replace('A.P.', '').split('.').join('');
                } else {
                    vm.errorCode = response.status.toString;
                }
                switch (vm.errorCode) {
                case '4012':
                case '4013':
                case '4014':
                    vm.errorText = config.loginerrors[vm.errorCode];
                    break;
                case '4015':
                    $state.go('notAllowed', {
                        data: response
                    });
                    break;
                default:
                    console.log('Error: ' + vm.errorCode); // eslint-disable-line no-console
                    break;
                }
            }

            /*
             * check if a user is logged in and set the userdata for porting process (will be called on initial screen init)
             */
            vm.initNBA = function(successPage) {
                $rootScope.loading = true;
                vm.successPage = successPage || 'porting-logged';
                mnpNbaProvider.nba().then(handleNbaSuccess, handleNbaError);
            };

            /*
             * check if a user is logged in and send back to home then (will be called on login forms)
             */
            vm.checkNBA = function() {
                $rootScope.loading = true;
                mnpNbaProvider.nba().then(function() {
                    $state.go('home');
                },
                function() {
                    $rootScope.loading = false;
                });
            };

            /**
             * this NBA success handler will only be called after login
             */
            function handleNbaSuccess(response) {
                window.portingUser = response.data;
                window.portingUser.BAN = window.portingUser.BAN || null;

                // add subscriberList to applications userdata
                var fullSubscriberList = [];
                if ('undefined' !== typeof window.portingUser.possibleSubscribers) {

                    // create list of possible subscribers if existing
                    for (var i = 0; i < window.portingUser.possibleSubscribers.length; i++ ){
                        if ('undefined' !== typeof window.portingUser.possibleSubscribers[i].listOfSubscribers){
                            var listOfSubscribers = window.portingUser.possibleSubscribers[i].listOfSubscribers.split(',');

                            // if no BAN in NBA response, try to find in subscriberlists
                            if (!window.portingUser.BAN){
                                for (var i = 0; i < listOfSubscribers.length; i++ ){
                                    if (listOfSubscribers[i] === window.portingUser.MSISDN){
                                        window.portingUser.BAN = window.portingUser.possibleSubscribers[i].BAN;
                                    }
                                }
                            }

                            // merge subscribers to full list of subscribers
                            fullSubscriberList.concat(listOfSubscribers);
                        }
                    }

                }
                window.portingUser.fullSubscriberList = fullSubscriberList;

                if (1 >= fullSubscriberList.length) {
                    if (!window.portingUser.MSISDN) {
                        // set the single msisdn from possible subscriberList as selected msisdn in BE session and reload page
                        mnploginProvider.changeMSISDN(fullSubscriberList[0]);
                        $state.reload();
                    } else {
                        // store the msisdn from nba data in cookie as selected msisdn
                        mnpCookieService.setValue('MSISDN', window.portingUser.MSISDN);
                    }
                }

                if (!window.portingUser.MSISDN) {
                    // MSISDN can't be determined, show contractchooser
                    mnpNbaProvider.showContractChooser();
                } else {
                    if ('porting-logged' === vm.successPage) {
                        window.location.href = '/shop/authentifizierung.html?btype=mnp&goto=%2Fhilfe%2Frufnummernmitnahme%2Fstart.html';
                    } else {
                        $state.go(vm.successPage);
                    }
                }

            }

            function handleNbaError(response) {
                var disableLoading = true;
                switch (response.status) {
                case 999:
                    break;
                case 400:
                    vm.errorCode = 400;
                    break;
                case 401:
                    if ('object' === typeof response.data && 'string' === typeof response.data.responseCode) {
                        switch (response.data.responseCode) {
                        case 'N.G.401.2':
                            vm.errorCode = 4012;
                            mnpNbaProvider.showContractChooser();
                            disableLoading = false;
                            break;
                        case 'N.G.401.3':
                            vm.errorCode = 4013;
                            break;
                        case 'N.G.401.4':
                            vm.errorCode = 4014;
                            break;
                        case 'N.G.401.1':
                            break;
                        case 'N.G.401.7':
                            vm.errorCode = 4017;
                            break;
                        case 'N.G.401.9':
                            vm.errorCode = 4019;
                            break;
                        default:
                            vm.errorCode = 401;
                            break;
                        }
                    } else {
                        vm.errorCode = 401;
                    }
                    break;
                case 409:
                    break;
                case 413:
                    vm.errorCode = 413;
                    break;
                default:
                    vm.errorCode = 401;
                    break;
                }
                if (disableLoading){
                    $rootScope.loading = false;
                }
            };

            /**
             * just an alias to access from view
             */
            vm.logout = function() {
                $rootScope.loading = true;
                mnpNbaProvider.logout();
            };
        };
    }
})();
